import { render, staticRenderFns } from "./UnassignedTeacherFilter.vue?vue&type=template&id=7da5128e&"
import script from "./UnassignedTeacherFilter.vue?vue&type=script&lang=js&"
export * from "./UnassignedTeacherFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports